import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 34.5 29.5",
	style: { enableBackground: "new 0 0 34.5 29.5" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.book-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "book-icon-st0",
		d: "M17.2,6c0-1.3,0.5-2.6,1.5-3.5C19.7,1.5,20.9,1,22.2,1h10c0.3,0,0.6,0.1,0.9,0.4c0.2,0.2,0.4,0.6,0.4,0.9v20 c0,0.3-0.1,0.6-0.4,0.9c-0.2,0.2-0.6,0.4-0.9,0.4h-10c-1.3,0-2.6,0.5-3.5,1.5c-0.9,0.9-1.5,2.2-1.5,3.5"
	}), /* @__PURE__ */ _jsx("path", {
		className: "book-icon-st0",
		d: "M1,22.2c0,0.3,0.1,0.6,0.4,0.9c0.2,0.2,0.6,0.4,0.9,0.4h10c1.3,0,2.6,0.5,3.5,1.5c0.9,0.9,1.5,2.2,1.5,3.5V6 c0-1.3-0.5-2.6-1.5-3.5C14.8,1.5,13.6,1,12.2,1h-10C1.9,1,1.6,1.1,1.4,1.4C1.1,1.6,1,1.9,1,2.2V22.2z"
	})] }) })]
});
export default SvgBookIcon;
